module.exports = __webpack_public_path__ + "media/country_flags/pe-bdddea6e.png";